import React, { FC, useRef } from 'react'
import { View } from 'react-native'
import { TooltipIcon } from './TooltipIcon'
import { PopoverPlacement } from '@ui-kitten/components/ui/popover/type'
import { BtPlainText } from '@linqpal/components/src/ui'
import { useHover } from 'react-native-web-hooks'

interface ITooltipLabelProps {
  label: string
  tooltip: string
  tooltipTitle?: string
  tooltipPosition?: PopoverPlacement
  labelStyle: any
  hoveredLabelStyle?: any
}

export const TooltipLabel: FC<ITooltipLabelProps> = ({
  label,
  tooltip,
  tooltipTitle,
  tooltipPosition,
  labelStyle,
  hoveredLabelStyle,
}) => {
  const labelRef = useRef(null)
  const isHovered = useHover(labelRef)

  // TODO: VK: use div instead of BtPlainText

  return (
    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
      <BtPlainText
        style={[
          labelStyle,
          { marginRight: 5 },
          isHovered ? hoveredLabelStyle : {},
        ]}
        ref={labelRef}
      >
        {label}
      </BtPlainText>
      <TooltipIcon
        tooltip={tooltip}
        title={tooltipTitle}
        tooltipPosition={tooltipPosition}
      />
    </View>
  )
}
